// Article filter component
export const eventFilterComponent = '[data-search-events]';
export const resourceFilterComponent = '[data-search-resources]';
export const filterKeywordSearch = '[data-keyword-search]';

export const lazyLoadComponent = '[data-show-more]';
export const paginationComponent = '[data-pagination]';

export const mapKeywordSearchLabels: Map<string, string> = new Map([
	['Teachers & Schools', 'Teachers & Schools'],
	['Families', 'Families'],
	['News', 'News'],
	['Careers', 'Careers'],
]);

export const mapPostTypeLabels: Map<string, string> = new Map([['Pages', 'Page']]);



// WEBPACK FOOTER //
// ./scripts/components/index.ts